/* eslint-disable no-debugger */
import { AvatarModal } from 'components/avatar-modal';
// import Header from 'components/header';
import { NavMobile } from 'components/nav-mobile';
import { RegulamentoModal } from 'components/regulamento-modal';
import { ContaDesativada } from 'pages/ContaDesativada';
// import Sidebar from 'components/sidebar';
// import { TabBar } from 'components/tabbar';
import { ReactNode, useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { validateUserPermissions } from '../utils/validateUserPermissions';

interface IPrivateRoute {
  permissions?: string[];
  roles?: string[];
  redirectTo?: string;
  children: ReactNode;
}

export function PrivateRoute({ permissions, roles, redirectTo = '/login', children }: IPrivateRoute) {
  const { isAuthenticated, user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const { hasAllPermissions } = validateUserPermissions({
    user,
    permissions,
    roles,
  });

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });

  if (!isAuthenticated) {
    if (location.pathname !== '/login' && location.pathname !== '/') {
      sessionStorage.setItem('return', location.pathname);
    }

    return <Navigate to={{ pathname: redirectTo, search: location.search }} />;
  }

  if (!hasAllPermissions) {
    return <Navigate to="/" />;
  }

  /* Conta desativada barra o app inteiro, e por isso a checagem mora aqui e não
     numa página: `Dashboard` é o elemento da rota "/", não um layout — as outras
     25 rotas são irmãs dela. Uma guarda lá dentro deixaria /extrato, /galeria e
     todo o resto acessíveis por link direto.
     Estritamente === false: quem não tem o campo é participante normal, e tratar
     ausente como desativado trancaria todo mundo para fora. */
  if (user?.extra?.active === false) {
    return <ContaDesativada />;
  }

  return (
    <>
      {isTabletOrMobile && <NavMobile />}
      <>{children}</>
      <RegulamentoModal />
      <AvatarModal />
    </>
  );
}
